import _ from "lodash";

export const captureUIEvent = (eventName: string, eventBody: object) => {
  _.invoke(window, "posthog.capture", eventName, eventBody);
};
